import request from "@/api/request";

export function getIdeaCode() {
    return request({
        url: '/api/reptile/getIdeaCode',
        method: 'get'
    })
}

export function getChicken() {
    return request({
        url: '/api/reptile/getChicken',
        method: 'get'
    })
}
